// @flow
import { connect } from 'react-redux';
import TermsService from '../components/TermsService';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
  }
}

export default connect(mapStateToProps)(TermsService);



// WEBPACK FOOTER //
// ./src/modules/terms-service/containers/TermsServiceContainer.js